import React from 'react';

import CampaignPostingLayout from './CampaignPostingLayout.jsx';
import CampaignPlayOldLayout from './CampaignPlayOldLayout.jsx';
import CampaignPlayLocalParam5 from './LocalParam5CampaignLayout/CampaignPlayLocalParam5.jsx';
import Header from './Header.jsx';
import Gantt from './Gantt.jsx';
import LoadingIndicator from '../LoadingIndicator.jsx'
import OrderService from '../../services/orderService.js'
import QueryStringService from '../../services/queryStringService.js';
import HashParameterService from '../../services/hashParameterService.js'
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
require('moment-weekday-calc');

const NEW_PLAYOUT_LOCAL_PARAM5 = ['SOV', 'SOVP', 'FXP', 'VAC', 'SFI'];

export default class PoPCampaign extends React.Component {
    constructor(props) {
        super(props);
        this.bg = Math.floor(Math.random() * 3) + 1;
        this.orderService = new OrderService();
        this.queryStringService = new QueryStringService();
        this.hashParamService = new HashParameterService();
        const hashIds = this.hashParamService.getParameter('orderlines');
        this.urlOrderLineIds = hashIds ? hashIds.split(",") : [];
        this.startDate = this.hashParamService.getParameter('startDate');
        this.endDate = this.hashParamService.getParameter('endDate');
        this.startDatePlay = null;
        this.endDatePlay = null;
        this.startDatePosting = null;
        this.endDatePosting = null;
        this.handleGanttExpanded = this.handleGanttExpanded.bind(this);
        this.state = {
            loading: false,
            ganttExpanded: !hashIds,
            postingPeriod: 0
        };

    }

    componentDidMount() {
        if (this.urlOrderLineIds.length) {
            let orderlines = this.props.orderData.orderLines.map((x) => { return x.id; });
            for (let i = 0; i < this.urlOrderLineIds.length; i++) {
                if (orderlines.indexOf(this.urlOrderLineIds[i]) === -1) {
                    //in case any orderline in the URL is not in the orderlines for the order the user logs in with
                    //the Gantt view shall open and no orderlines shall be pre-fetched from the API
                    this.setState({
                        ganttExpanded: true
                    });
                    return;
                }
            }
            this.handleLoadOrderLines(this.urlOrderLineIds, this.startDate, this.endDate);
        }
    }

    handleGanttExpanded() {
        if (this.state.ganttExpanded) {
            this.setState({ ganttExpanded: false });
        }
        else {
            this.setState({ ganttExpanded: true });
        }
        return this.state.ganttExpanded;
    }

    handleLoadOrderLines(orderLineIds, startDate, endDate) {

        let self = this;
        let orderLines = this.props.orderData.orderLines;
        let selectedOrderLines = [];
        for (let i = 0; i < orderLines.length; i++) {
            if (orderLineIds.indexOf(orderLines[i].id) !== -1) {
                selectedOrderLines.push(orderLines[i]);
            }
        }
        this.setState({
            loading: true,
            ganttExpanded: false,
            orderLinesData: null
        });
        let country = this.queryStringService.getCurrentCountry();
        this.orderService.getOrderLines(this.props.customerId, selectedOrderLines, startDate, endDate, country, (orderLinesData) => {
            if (!orderLinesData) {
                self.setState({
                    loading: false
                });
                console.log("No orderline data found");
                return;
            }
            this.hashParamService.updateParameter('startDate', startDate);
            this.hashParamService.updateParameter('endDate', endDate);
            this.hashParamService.updateParameter('orderlines', orderLineIds.join());
            this.urlOrderLineIds = orderLineIds;

            //selectedOrderLines[0].localParameter5 = 'SOVP';

            self.setState({
                    loading: false,
                    orderLinesData: orderLinesData,
                    selectedOrderLines : selectedOrderLines,
                    selectedCampaignType: orderLinesData.playData ? "play" : "posting",
                    campaignName: orderLineIds.length === 1 ? this.props.orderData.orderLines.filter(x => x.id === orderLineIds[0])[0].name : ''
                });

        }, () => {
            toast.error("Something went wrong! Try again or contact support.");
            this.setState({
                ganttExpanded: true,
                loading: false
            });
        });
    }

    render() {

        let showPod = false;
        let showNewPlay = false;
        let showOldPlay = false;
        const showPosting = this.state.orderLinesData && this.state.selectedCampaignType == "posting";
        if (this.state.selectedOrderLines &&
            this.state.selectedOrderLines.length > 0 &&
            this.state.selectedOrderLines[0].localParameter5 &&
            NEW_PLAYOUT_LOCAL_PARAM5.includes(this.state.selectedOrderLines[0].localParameter5.toUpperCase()) &&
            moment(this.state.selectedOrderLines[0].createdOn) >= moment(this.props.parameters.clientSettings.newLayoutForLocal5ParamAfterOrderlineCreationDate)
        ) {
            showNewPlay = this.state.orderLinesData && this.state.selectedCampaignType == "play";
        }
        else {
            showOldPlay = this.state.orderLinesData && this.state.selectedCampaignType == "play";
        }

        return (
            <div>
                <LoadingIndicator loading={this.state.loading} text={this.props.parameters.loadingDataText} />
                <div>
                    <div className="container">
                        <Header customer={this.props.orderData.customer}
                            ordername={this.props.orderData.name} />
                    </div>
                    <div className="container" id="gantt_menu">
                        {!this.state.underConstruction &&
                            <button className={this.state.ganttExpanded ? "ganttToggleBtn ganttToggleBtn--exp" : "ganttToggleBtn"}
                                onClick={() => { this.handleGanttExpanded() }}
                            >Select Campaigns</button>
                        }
                        <Gantt
                            expanded={this.state.ganttExpanded}
                            toggleExpanded={this.handleGanttExpanded}
                            data={this.props.orderData.orderLines}
                            selectedOrderLineIds={this.urlOrderLineIds}
                            startDay={this.startDate}
                            endDay={this.endDate}
                            onLoadOrderLines={(orderLineIds, startDate, endDate) => this.handleLoadOrderLines(orderLineIds, startDate, endDate)} />
                    </div>
                    {!this.state.loading && showPosting &&
                        <CampaignPostingLayout
                            orderData={this.props.orderData}
                            customerId={this.props.customerId}
                            orderLinesData={this.state.orderLinesData}
                            parameters={this.props.parameters}
                            urlOrderLineIds={this.urlOrderLineIds}
                            startDate={this.startDate}
                            endDate={this.endDate}
                        />}
                    {!this.state.loading && showOldPlay &&
                        <CampaignPlayOldLayout
                            orderData={this.props.orderData}
                            customerId={this.props.customerId}
                            orderLinesData={this.state.orderLinesData}
                            selectedOrderLines={this.state.selectedOrderLines}
                            parameters={this.props.parameters}
                            urlOrderLineIds={this.urlOrderLineIds}
                            startDate={this.startDate}
                            endDate={this.endDate}
                        />}
                    {!this.state.loading && showNewPlay &&
                        <CampaignPlayLocalParam5
                            orderData={this.props.orderData}
                            customerId={this.props.customerId}
                            orderLinesData={this.state.orderLinesData}
                            selectedOrderLines={this.state.selectedOrderLines}
                            parameters={this.props.parameters}
                            urlOrderLineIds={this.urlOrderLineIds}
                            startDate={this.startDate}
                            endDate={this.endDate}
                        />}
                </div>
            </div>
        );
    }
}
